module.exports = __webpack_public_path__ + "img/terminal.002df5ad.svg";